import React from 'react'

import FlexBox from '../../flexBox/FlexBox'
import { FlexBoxProps } from '../../flexBox/_props'

const FormContainer: React.FC<FlexBoxProps> = ({ gap = '2.125rem', flexDirection = 'column', children, ...props }) => (
    <FlexBox flexDirection={flexDirection} gap={gap} {...props}>
        {children}
    </FlexBox>
)

export default FormContainer
